import { createSlice } from '@reduxjs/toolkit';
import { ThresholdState } from './types';
import {
  getThresholdData,
  getDLZData,
  getExternalWarehousesSaturation as getExternalWarehousesSaturationThunk
} from './async';

export const GREEN = 'green700';

export const initialState: ThresholdState = {
  workshopId: 'T12',
  thresholdData: [],
  DLZData: {
    materialCoverageMaxThreshold: '0',
    dlzMaxTimeMinutes: 0,
    modifiedAt: '',
    modifiedBy: ''
  },
  externalWarehousesSaturationData: [],
  thresholdDataRequestStatus: '',
  DLZDataRequestStatus: '',
  externalWarehousesSaturationDataRequestStatus: ''
};

const thresholdDateSlice = createSlice({
  name: 'thresholdDateSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //threshold
    builder.addCase(getThresholdData.fulfilled, (state, action) => {
      state.thresholdData = action.payload || [];
      state.thresholdDataRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getThresholdData.pending, (state, action) => {
      state.thresholdDataRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getThresholdData.rejected, (state, action) => {
      state.thresholdDataRequestStatus = action.meta.requestStatus;
    });
    //PLZ
    builder.addCase(getDLZData.fulfilled, (state, action) => {
      state.DLZData = action.payload || [];
      state.DLZDataRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getDLZData.pending, (state, action) => {
      state.DLZDataRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getDLZData.rejected, (state, action) => {
      state.DLZDataRequestStatus = action.meta.requestStatus;
    });
    //External warehouses saturation
    builder.addCase(
      getExternalWarehousesSaturationThunk.fulfilled,
      (state, action) => {
        state.externalWarehousesSaturationData = action.payload || [];
        state.externalWarehousesSaturationDataRequestStatus =
          action.meta.requestStatus;
      }
    );
    builder.addCase(
      getExternalWarehousesSaturationThunk.pending,
      (state, action) => {
        state.externalWarehousesSaturationDataRequestStatus =
          action.meta.requestStatus;
      }
    );
    builder.addCase(
      getExternalWarehousesSaturationThunk.rejected,
      (state, action) => {
        state.externalWarehousesSaturationDataRequestStatus =
          action.meta.requestStatus;
      }
    );
  }
});

//selectors
export const getThreshold = (state) =>
  state.thresholdDateSliceState.thresholdData;
export const getDLZ = (state) => state.thresholdDateSliceState.DLZData;
export const getExternalWarehousesSaturation = (state) =>
  state.thresholdDateSliceState.externalWarehousesSaturationData;

export const getThresholdRequestStatusIsPending = (state) =>
  state.thresholdDateSliceState.thresholdDataRequestStatus === 'pending';
export const getThresholdRequestStatusHasError = (state) =>
  state.thresholdDateSliceState.thresholdDataRequestStatus === 'rejected';
export const getThresholdRequestStatusIsSucessfull = (state) =>
  state.thresholdDateSliceState.thresholdDataRequestStatus === 'fulfilled';

export const getDLZRequestStatusIsPending = (state) =>
  state.thresholdDateSliceState.DLZDataRequestStatus === 'pending';
export const getDLZRequestStatusHasError = (state) =>
  state.thresholdDateSliceState.DLZDataRequestStatus === 'rejected';
export const getDLZRequestStatusIsSucessfull = (state) =>
  state.thresholdDateSliceState.DLZDataRequestStatus === 'fulfilled';

export const getExternalWarehousesSaturationRequestStatusIsPending = (state) =>
  state.thresholdDateSliceState
    .externalWarehousesSaturationDataRequestStatus === 'pending';
export const getExternalWarehousesSaturationRequestStatusHasError = (state) =>
  state.thresholdDateSliceState
    .externalWarehousesSaturationDataRequestStatus === 'rejected';
export const getExternalWarehousesSaturationRequestStatusIsSucessfull = (
  state
) =>
  state.thresholdDateSliceState
    .externalWarehousesSaturationDataRequestStatus === 'fulfilled';

export const getWorkshopId = (state) =>
  state.thresholdDateSliceState.workshopId;

export const getExternalWarehousesSaturationData = (state) =>
  state.thresholdDateSliceState.externalWarehousesSaturationData;

export const getThresholdsValues = (state: any) => {
  const thresholdState: ThresholdState = state.thresholdDateSliceState;

  const valueT12M =
    thresholdState.thresholdData.find(
      (threshold) => threshold.workshopId === 'T12M'
    )?.thresholdCapacity ?? '0';

  const valueT12AGL =
    thresholdState.thresholdData.find(
      (threshold) => threshold.workshopId === 'T12AGL'
    )?.thresholdCapacity ?? '0';

  const valueT12AKL =
    thresholdState.thresholdData.find(
      (threshold) => threshold.workshopId === 'T12AKL'
    )?.thresholdCapacity ?? '0';

  const valueCobertura =
    thresholdState.DLZData?.materialCoverageMaxThreshold ?? '0';

  const valueDLZ = thresholdState.DLZData?.dlzMaxTimeMinutes ?? 0;

  return {
    valueT12M,
    valueT12AGL,
    valueT12AKL,
    valueCobertura,
    valueDLZ
  };
};

/**export const {
  updateSelectedHourEntryType,
  updateSelectedDaysEntryType,
  updateSelectedHour
} = chartDateSlice.actions;*/
export default thresholdDateSlice.reducer;
